export default {
  mounted(el) {
    // 强制样式
    el.style.position = 'fixed';
    el.style.zIndex = 999999;
    el.style.cursor = 'move';
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.transform = 'translate(-50%, -50%)';

    // 👇 最强方案：绑定到 document，永远能触发！
    function startDrag(e) {
      // 只允许左键
      if (e.button !== 0) return;

      // 判断是否点击在当前元素内
      const rect = el.getBoundingClientRect();
      const inLeft = e.clientX >= rect.left && e.clientX <= rect.right;
      const inTop = e.clientY >= rect.top && e.clientY <= rect.bottom;
      if (!inLeft || !inTop) return;

      e.preventDefault();
      const dx = e.clientX - rect.left;
      const dy = e.clientY - rect.top;

      function move(e) {
        let left = e.clientX - dx;
        let top = e.clientY - dy;
        el.style.left = left + 'px';
        el.style.top = top + 'px';
        el.style.transform = 'none';
      }

      function up() {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      }

      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    }

    // 👇 关键：把事件绑在 document 上，永远不会被拦截！
    document.addEventListener('mousedown', startDrag);

    // 销毁时清理
    return () => {
      document.removeEventListener('mousedown', startDrag);
    };
  }
};